import { render, staticRenderFns } from "./static-category-block.vue?vue&type=template&id=efcef076&"
import script from "./static-category-block.vue?vue&type=script&lang=js&"
export * from "./static-category-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports